var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    {
      staticClass:
        "inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium",
      class: [_vm.status.class]
    },
    [_vm._v("\n    " + _vm._s(_vm.status.name) + "\n")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /Users/matej/Works/Code/mago/wp-content/themes/sage/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/Users/matej/Works/Code/mago/wp-content/themes/sage/node_modules/vue-loader/lib?{}!./scripts/vue/auth/partials/OrderStatus.vue?vue&type=template&id=0a8b9a66&
// module id = 188
// module chunks = 0